import { Card, CardBody, Content, ContentVariants, Grid, GridItem } from "@patternfly/react-core";
import type { FC } from "react";
import { useProductScoreMetadata } from "../../hooks/useProductScoreMetadata";
import { ProductScoreActionItem } from "../ProductDetailsWrapper/ProductDetailHeader/ProductScore/ProductScoreActionItem";
import { SkeletonContainer } from "./Skeleton";
import "./ProductScoreOverview.scss";
import { useProductMetadata } from "../../hooks/useProductMetadata";

export const ProductScoreOverview: FC = () => {
	const { productDetail, certificationListState, isPartnerValidationSupported } = useProductMetadata();
	const {
		scoreStatus,
		statusColor,
		apiProductScoreItems,
		isProductScoreLoading: isFetching,
	} = useProductScoreMetadata();
	return (
		<Card isFullHeight>
			<CardBody>
				{isFetching ? (
					<SkeletonContainer />
				) : (
					<Grid hasGutter>
						<Content>
							<Content component={ContentVariants.h2}>Product Readiness Score</Content>
						</Content>
						<GridItem>
							<Content>
								<Content component={ContentVariants.h3} style={{ color: statusColor, fontSize: "1.5em" }}>
									{scoreStatus}
								</Content>
							</Content>
						</GridItem>
						{apiProductScoreItems?.length > 0 && (
							<>
								<GridItem>
									<Content>
										<Content component={ContentVariants.h3}>Ways to raise your score</Content>
									</Content>
								</GridItem>
								<GridItem className="overview-list-grid-item">
									{apiProductScoreItems.map((item, index) => (
										<ProductScoreActionItem
											key={index}
											title={item.title}
											htmlDescription={item.description}
											buttonText={item.buttonText}
											buttonType={item.buttonType}
											buttonPath={item.buttonPath}
										/>
									))}
									{isPartnerValidationSupported &&
										certificationListState?.length === 0 &&
										productDetail?.product_validation?.partner_validated === true && (
											<ProductScoreActionItem
												key={"score"}
												title={"Certify your product"}
												htmlDescription={"Achieve the next level for your product by adding and certifying components"}
												buttonText={"Certify your product"}
												buttonType={"link"}
												buttonPath={"components"}
											/>
										)}
								</GridItem>
							</>
						)}
					</Grid>
				)}
			</CardBody>
		</Card>
	);
};
